<template>
  <div class="attr-list v-talbe-attr">
    <CommonAttr />
    <EditTable />
    <el-form>
      <el-form-item label="斑马纹">
        <el-switch v-model="propValue.stripe" />
      </el-form-item>
      <el-form-item label="表头加粗">
        <el-switch v-model="propValue.thBold" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import CommonAttr from '../common/CommonAttr'
import EditTable from './EditTable'

export default {
  components: { EditTable, CommonAttr },
  computed: {
    propValue() {
      return this.$store.state.curComponent.propValue
    }
  }
}
</script>
